console.log('[MAIN] 1. Início do main.jsx - Build:', Date.now());
console.log('[MAIN] 1.5. React alias fix applied');
console.log('[MAIN] 2. Importando React...');
import React from 'react';
console.log('[MAIN] 3. React importado:', React);
console.log('[MAIN] 4. React.useState:', React.useState);
console.log('[MAIN] 5. Importando createRoot...');
import { createRoot } from 'react-dom/client'
console.log('[MAIN] 6. createRoot importado:', createRoot);
console.log('[MAIN] 7. Importando CSS...');
import './index.css'
console.log('[MAIN] 8. CSS importado');
console.log('[MAIN] 9. Importando App...');
import App from './App.jsx'
console.log('[MAIN] 9.5. Importando ErrorBoundary...');
import ErrorBoundary from './components/ErrorBoundary.jsx';
console.log('[MAIN] 10. App e ErrorBoundary importados');

console.log('[MAIN] 11. Procurando elemento root...');
const rootElement = document.getElementById('root');
console.log('[MAIN] 12. Root element:', rootElement);

console.log('[MAIN] 13. Criando root...');
const root = createRoot(rootElement);
console.log('[MAIN] 14. Root criado:', root);

console.log('[MAIN] 15. Renderizando App...');
try {
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
  console.log('[MAIN] 16. App renderizado com sucesso!');
} catch (error) {
  console.error('[MAIN] ERRO AO RENDERIZAR:', error);
  console.error('[MAIN] Stack:', error.stack);
  document.body.innerHTML = `<div style="color:red;padding:20px;font-family:monospace;">
    <h1>ERRO DE RENDERIZAÇÃO</h1>
    <pre>${error.message}\n\n${error.stack}</pre>
  </div>`;
}
